import React, { FC } from 'react';
import { HeartProps } from './types';
import './styles/heart.css';
import HeartImage from '../assets/images/heart.png';

export const Heart: FC<HeartProps> = ({ life }) => {
    const fixedNumber = 3;

    return (
        <div className='heartLife'>
            <img src={HeartImage} />
            {Array.from({ length: fixedNumber }).map((_, index) => (
                <div
                    key={index}
                    style={{
                        opacity: index < life ? 1 : 0.2, // Opacità in base al numero variabile
                    }}
                ></div>
            ))}
        </div>
    );
};
